import React, { CSSProperties } from 'react';
import { FormControl, MenuItem } from '@mui/material';
import { AntSwitch, StyledCheckbox, StyledRadioCheckbox } from '../../utils/commonStyles.Styled';
import {
  StyledTypography,
  StyledSelect,
  StyledListItemText,
  DropdownContainer,
  DropdDownGrid,
  SelectAllContainer,
} from './FilterDropDown.Styled';
import { getDropdownStyles, getinputPropsStyles } from '../../utils/helper';

interface DropdownMenuProps {
  label: string;
  selectedValues: string[];
  allKeys: string[];
  singleSelect: boolean;
  selectAll: boolean;
  isOpen: boolean;
  loading: boolean;
  setIsOpen: (value: boolean) => void;
  handleSelectAllToggle: () => void;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClose: () => void;
  customStyles?: CSSProperties;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  label,
  selectedValues,
  allKeys,
  singleSelect,
  selectAll,
  isOpen,
  loading,
  setIsOpen,
  handleSelectAllToggle,
  handleChange,
  handleClose,
  customStyles,
}) => {
  return (
    <FormControl
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      disabled={loading}
    >
      <StyledTypography>{label}</StyledTypography>
      <StyledSelect
        style={{ background: '#F8F8F8', ...customStyles }}
        value={singleSelect ? selectedValues[0] : selectedValues}
        onClose={handleClose}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        multiple={!singleSelect}
        MenuProps={{
          PaperProps: {
            style: {
              width: '190px',
              fontSize: '9px',
              borderRadius: '10px',
            },
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
        }}
        renderValue={(selected) => {
          if (!singleSelect) {
            if (Array.isArray(selected)) {
              if (selected.length === 1) {
                return selected[0];
              } else if (selected.length === allKeys.length) {
                return 'All';
              } else {
                return `Multiple`;
              }
            }
            return '';
          } else {
            return selected;
          }
        }}
        sx={getDropdownStyles('#E81C0E')}
        inputProps={{
          sx: getinputPropsStyles('#E81C0E'),
        }}
      >
        <DropdownContainer>
          {!singleSelect && (
            <SelectAllContainer>
              <span>Select All {label}</span>
              <AntSwitch checked={selectAll} onChange={handleSelectAllToggle} color="primary" />
            </SelectAllContainer>
          )}
          <DropdDownGrid
            style={{
              height: '229px',
              overflowY: 'auto',
            }}
          >
            {allKeys
              .sort((a, b) => a.localeCompare(b))
              .map((name) => (
                <MenuItem
                  style={{ padding: 0, minHeight: '14px', marginTop: '5px' }}
                  key={name}
                  value={name}
                  onClick={(event) => {
                    const isChecked = selectedValues.includes(name);
                    const eventTarget = {
                      target: { value: name, checked: !isChecked },
                    } as React.ChangeEvent<HTMLInputElement>;
                    handleChange(eventTarget);
                  }}
                >
                  {!singleSelect ? (
                    <StyledCheckbox
                      value={name}
                      checked={selectedValues.includes(name)}
                      onChange={handleChange}
                      onClick={(e) => e.stopPropagation()}
                    />
                  ) : (
                    <StyledRadioCheckbox
                      value={name}
                      checked={selectedValues.includes(name)}
                      onChange={handleChange}
                      onClick={(e) => e.stopPropagation()}
                    />
                  )}

                  <StyledListItemText
                    primary={name}
                    onClick={(event) => {
                      event.stopPropagation();
                      const isChecked = selectedValues.includes(name);
                      const eventTarget = {
                        target: { value: name, checked: !isChecked },
                      } as React.ChangeEvent<HTMLInputElement>;
                      handleChange(eventTarget);
                    }}
                  />
                </MenuItem>
              ))}
          </DropdDownGrid>
        </DropdownContainer>
      </StyledSelect>
    </FormControl>
  );
};

export default DropdownMenu;
